import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  Change,
  LoaderOverlay,
  Reset,
} from "../../async-actions/digitalmarketing/header";

interface HeaderState {
  status: boolean;
  title: string;
  overlay: any;
}

const initialState: HeaderState = {
  status: false,
  title: "",
  overlay: false,
};

const HeaderSlice = createSlice({
  name: "header",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(Change, (state, action: PayloadAction<string>) => {
        state.status = true;
        state.title = action.payload;
      })
      .addCase(Reset, (state) => {
        state.status = false;
      })
      .addCase(LoaderOverlay.fulfilled, (state, action) => {
        state.overlay = action.payload;
      });
  },
});

export default HeaderSlice.reducer;
